export default "__VITE_ASSET__cf99346f__"